import { GEButton } from '../../../../../common/buttons'
import { FC, useState } from 'react'
import { Tooltip } from 'antd'
import * as API_WORDLIST from '../../../../../shared/http/word-list'
import { fetchWords } from '../../../../../store/words/extraReducers'
import { useAppDispatch } from '../../../../../store/hooks'
import {TbLetterCase, TbQuestionMark} from "react-icons/tb";

interface UpperCaseWordsButtonProps {
    selectedCategory: any,
    wordsAmount: number,
}

const UpperCaseWordsButton: FC<UpperCaseWordsButtonProps> = ({
                                                                   selectedCategory,
                                                                   wordsAmount

                                                               }) => {
    const isVisible = selectedCategory !== null && wordsAmount > 0

    const [loading, setLoading] = useState<boolean>(false)
    const dispatch = useAppDispatch()
    const getWords = (id: number) => dispatch(fetchWords(id))

    const switchSidesWordList = () => {
        setLoading(true)
        API_WORDLIST.makeLettersUppercase(selectedCategory.id as number).then(r => {
            getWords(selectedCategory.id).finally(() => {
                setLoading(false)
            })
        }).finally(() => {
            setLoading(false)
        })
    }

    return (
        <div
            className={isVisible ? '' : 'ge-invisible'}
        >
            <Tooltip placement='topLeft' title='Сделать первые буквы заглавными'>
                <GEButton icon={<TbLetterCase />} loading={loading} onClick={switchSidesWordList}/>
            </Tooltip>
        </div>
    )
}

export default UpperCaseWordsButton